import { render } from "./ThirdParty.vue?vue&type=template&id=3b44e579&scoped=true"
const script = {}

import "./ThirdParty.vue?vue&type=style&index=0&id=3b44e579&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b44e579"]])

export default __exports__